import { moduleFactory } from "@/factories/module";
import {
  releaseAudioRecorderLock,
  takeAudioRecorderLock,
} from "@/modules/audio-recording/audio-recorder-lock";
import {
  convertAudioRecordingFloat32ToPcm16,
  decodeAudioRecordingBlobToAudioBuffer,
  encodeAudioRecordingPcm16ToBase64,
  resampleAudioRecordingBufferToMono,
} from "@/modules/audio-recording/audio-processing";
import {
  mapAssemblyAiTurnPayloadToRecorderTurn,
  normalizeAudioRecordingTimestamp,
  resolveAssemblyAiRealtimePayloadType,
} from "@/modules/audio-recording/audio-transcription";
import { assemblyAiTokenProvider } from "@/modules/audio-recording/assembly-ai";
import {
  buildRecorderChunkFromPcm,
  transformBlobToPlayableFormat,
  transformBlobToUploadFormat,
} from "@/modules/audio-recording/desktop-utils";
import { buildTranscriptPayload } from "@/modules/audio-recording/transcripts";
import {
  extractAudioRecordingIdFromBlobName,
  extractBlobNameFromDownloadUrl,
  extractCapturedAudioIdFromBlobName,
} from "@/modules/audio-recording/source-utils";

export const audioRecordingModule = moduleFactory.create({
  takeLock: takeAudioRecorderLock,
  releaseLock: releaseAudioRecorderLock,
  decodeBlobToAudioBuffer: decodeAudioRecordingBlobToAudioBuffer,
  resampleToMono: resampleAudioRecordingBufferToMono,
  convertFloat32ToPcm16: convertAudioRecordingFloat32ToPcm16,
  encodePcm16ToBase64: encodeAudioRecordingPcm16ToBase64,
  mapAssemblyAiTurnPayloadToRecorderTurn,
  normalizeAssemblyAiTimestamp: normalizeAudioRecordingTimestamp,
  assemblyAiTokenProvider: assemblyAiTokenProvider,
  resolveAssemblyAiRealtimePayloadType,
  buildRecorderChunkFromPcm,
  transformBlobToPlayableFormat,
  transformBlobToUploadFormat,
  buildTranscriptPayload,
  extractBlobNameFromDownloadUrl,
  extractAudioRecordingIdFromBlobName,
  extractCapturedAudioIdFromBlobName,
});
